import React from 'react';
import ImageDropzone from './ImageDropzone';

const DropzoneLowerImage = ({ onLowerImageDropHandler, lowerImagePath }) => (
  <ImageDropzone
    inputName="lowerImage"
    label="Lower Login Image"
    imagePath={lowerImagePath}
    alt="Lower login"
    onImageReady={onLowerImageDropHandler}
    prepareOptions={{ maxSize: 1600 }}
  />
);

export default DropzoneLowerImage;
